import React from 'react'
import PropTypes from 'prop-types'
import { triggerClickOnEnter, ACCESSIBILITY_CLASSES, TAB_INDEXES } from 'shared/helpers/AccessibilityHelper'

import './style.css.scss'

const BoardSocialLinks = ({ config, onShareClick }) => (
  <div className="share-options glyph">
    {
      Object.keys(config).map((type) => {
        if(config[type]) {
          return (
            <span
              key={type}
              className={`icon-${type} ${ACCESSIBILITY_CLASSES.main}`}
              onClick={() => onShareClick(type)}
              onKeyUp={triggerClickOnEnter}
              role="button"
              tabIndex={TAB_INDEXES.BoardSocialLinks} />
          )
        }
      })
    }
  </div>
  )


BoardSocialLinks.propTypes = {
  onShareClick: PropTypes.func.isRequired,
  config: PropTypes.object.isRequired
}

export default BoardSocialLinks
